module.exports = __webpack_public_path__ + "img/icon_radar-mode-on.84b78dc0.svg";